// extracted by mini-css-extract-plugin
module.exports = {"profileDescriptionTooltip":"ProfileDescriptionTooltip_profileDescriptionTooltip__3W1-k","goToBorrowerProfileButton":"ProfileDescriptionTooltip_goToBorrowerProfileButton__106WH"};